import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-chart-column",
  "use": "foquz-icon-chart-column-usage",
  "viewBox": "0 0 14 16",
  "content": "<symbol viewBox=\"0 0 14 16\" fill=\"none\" id=\"foquz-icon-chart-column\"><path d=\"M0 10h2v6H0v-6zm4-6h2v12H4V4zm4 2h2v10H8V6zm4-6h2v16h-2V0z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol